import { data } from 'browserslist';
import API from '../../../../../global/api';


export const postData = (data) =>{
    return(dispatch)=>{
        API.post(`/fl_342/add-fl-342-data`,data).then((res)=>{
            dispatch(successPostData(data));
        })
    }
}


export const requestPostData = ()=>{
    return{
        type: "REQUEST_POST_DATA",
    }
}

export const successPostData = (data) =>{
    return{
        type: "SUCCESS_POST_DATA",
        payload: data,
    }
}

export const errorPostData = (data) =>{
    return{
        type: "ERROR_POST_DATA",
        payload: data,
    }
}


//2nd Question Put Call


export const putCourtUsed = (data) => {
    return(dispatch)=>{
        API.post(`/fl_342/update-fl-342-print-out`,data).then((res)=>{
            dispatch(successPutCourtUsed(data));
        })
    }
}

export const requestPutCourtUsed = () =>{
    return{
        type:"REQUEST_PUT_COURT_USED",
    }
}

export const successPutCourtUsed = (data) =>{
    return{
        type:"SUCCESS_PUT_COURT_USED",
        payload: data,
    }
}

export const errorPutCourtUsed = (data) =>{
    return{
        type:"ERROR_PUT_COURT_USED",
        payload: data,
    }
}


//3rd Question Put Call


export const putIncome = (data) =>{
    return(dispatch)=>{
        API.put(`/fl_342/update-fl-342-income`,data).then((res)=>{
            dispatch(successPutIncome(data));
        })
    }
}

export const requestPutIncome = () =>{
    return{
        type:"REQUEST_PUT_INCOME",
    }
}

export const successPutIncome = (data) =>{
    return{
        type:"SUCCESS_PUT_INCOME",
        payload: data,
    }
}

export const errorPutIncome = (data) =>{
    return{
        type:"ERROR_PUT_INCOME",
        payload: data,
    }
}


//4th Question Put Call


export const putChildren = (data) =>{
    return(dispatch)=>{
        API.put(`/fl_342/update-fl-342-children-relation`,data).then((res)=>{
            dispatch(successPutChildren(data));
        })
    }
}

export const requestPutChildren = () =>{
    return{
        type:"REQUEST_PUT_CHILDREN",
    }
}

export const successPutChildren = (data) =>{
    return{
        type:"SUCCESS_PUT_CHILDREN",
        payload: data,
    }
}

export const errorPutChildren = (data) =>{
    return{
        type:"ERROR_PUT_CHILDREN",
        payload: data,
    }
}


//5th Question Put Call


export const putHardships = (data) =>{
    return(dispatch)=>{
        API.post(`fl_342/add-hardship-data`,data).then((res)=>{
            dispatch(successPutHardships(data));
        })
    }
}
export const requestPutHardships = () =>{
    return{
        type:"REQUEST_PUT_HARDSHIPS",
    }
}
export const successPutHardships = (data) =>{
    return{
        type:"SUCCESS_PUT_HARDSHIPS",
        payload: data,
    }
}
export const errorPutHardships = (data) =>{
    return{
        type:"ERROR_PUT_HARDSHIPS",
        payload: data,
    }
}


//6th Question Put Call


export const putLowIncome = (data) =>{
    return(dispatch)=>{
        API.put(`fl_342/update-fl-342-low-incom-adjustment`,data).then((res)=>{
            dispatch(successPutLowIncome(data));
        })
    }
}

export const requestPutLowIncome = () =>{
    return{
        type:"REQUEST_PUT_LOW_INCOME",
    }
}

export const successPutLowIncome = (data) =>{
    return{
        type:"SUCCESS_PUT_LOW_INCOME",
        payload: data,
    }
}

export const errorPutLowIncome = (data) =>{
    return{
        type:"ERROR_PUT_LOW_INCOME",
        payload: data,
    }
}


//7th Question Put Call


export const putChildSupport = (data) =>{
    return(dispatch)=>{
        API.post(`fl_342/child-basic-support`,data).then((res)=>{
            dispatch(successPutChildSupport(data));
        })
    }
}

export const requestPutChildSupport = () =>{
    return{
        type:"REQUEST_PUT_CHILD_SUPPORT",
    }
}

export const successPutChildSupport = (data) =>{
    return{
        type:"SUCCESS_PUT_CHILD_SUPPORT",
        payload: data,
    }
}

export const errorPutChildSupport = (data) =>{
    return{
        type:"ERROR_PUT_CHILD_SUPPORT",
        payload: data,
    }
}



//8th Question Put Call


export const putMandatoryChildSupport = (data) =>{
    return(dispatch)=>{
        API.post(`fl_342/mandatory-data-add-and-update`,data).then((res)=>{
            dispatch(successPutMandatoryChildSupport(data));
        })
    }
}

export const requestPutMandatoryChildSupport = () =>{
    return{
        type:"REQUEST_PUT_MANDATORY_CHILD_SUPPORT",
    }
}

export const successPutMandatoryChildSupport = (data) =>{
    return{
        
        type:"SUCCESS_PUT_MANDATORY_CHILD_SUPPORT",
        payload: data,
    }
}

export const errorPutMandatoryChildSupport = (data) =>{
    return{
        type:"ERROR_PUT_MANDATORY_CHILD_SUPPORT",
        payload: data,
    }
}



//9th Question Put Call


export const putAdditionalChildSupport = (data) =>{
    return(dispatch)=>{
        API.post(`fl_342/additional-data-add-and-update`,data).then((res)=>{
            dispatch(successPutAdditionalChildSupport(data));
        })
    }
}

export const requestPutAdditionalChildSupport = () =>{
    return{
        type:"REQUEST_PUT_ADDITIONAL_CHILD_SUPPORT",
    }
}

export const successPutAdditionalChildSupport = (data) =>{
    return{
        type:"SUCCESS_PUT_ADDITIONAL_CHILD_SUPPORT",
        payload: data,
    }
}

export const errorPutAdditionalChildSupport = (data) =>{
    return{
        type:"ERROR_PUT_ADDITIONAL_CHILD_SUPPORT",
        payload: data,
    }
}


//10th Question Put Call


export const putNonGuidelineOrder = (data) =>{
    return(dispatch)=>{
        API.put(`fl_342/update-fl-342-guide-line`,data).then((res)=>{
            dispatch(successPutNonGuidelineOrder(data));
        })
    }
}

export const requestPutNonGuidelineOrder = () =>{
    return{
        type:"REQUEST_PUT_NON_GUIDELINE_ORDER",
    }
}

export const successPutNonGuidelineOrder = (data) =>{
    return{
        type:"SUCCESS_PUT_NON_GUIDELINE_ORDER",
        payload: data,
    }
}

export const errorPutNonGuidelineOrder = (data) =>{
    return{
        type:"ERROR_PUT_NON_GUIDELINE_ORDER",
        payload: data,
    }
}


//11th Question Put Call


export const putHealthCareExpenses = (data) =>{
    return(dispatch)=>{
        API.put(`fl_342/health-care-expenses`,data).then((res)=>{
            dispatch(successPutHealthCareExpenses(data));
        })
    }
}

export const requestPutHealthCareExpenses = () =>{
    return{
        type:"REQUEST_PUT_HEALTH_CARE_EXPENSES",
    }
}

export const successPutHealthCareExpenses = (data) =>{
    return{
        type:"SUCCESS_PUT_HEALTH_CARE_EXPENSES",
        payload: data,
    }
}

export const errorPutHealthCareExpenses = (data) =>{
    return{
        type:"ERROR_PUT_HEALTH_CARE_EXPENSES",
        payload: data,
    }
}



//12th Question Put Call


export const putEmploymentSearchOrder = (data) =>{
    return(dispatch)=>{
        API.put(`fl_342/update-employ-search-order`,data).then((res)=>{
            dispatch(successPutEmploymentSearchOrder(data));
        })
    }
}

export const requestPutEmploymentSearchOrder = () =>{
    return{
        type:"REQUEST_PUT_EMPLOYMENT_SEARCH_ORDER",
    }
}

export const successPutEmploymentSearchOrder = (data) =>{
    return{
        type:"SUCCESS_PUT_EMPLOYMENT_SEARCH_ORDER",
        payload: data,
    }
}

export const errorPutEmploymentSearchOrder = (data) =>{
    return{
        type:"ERROR_PUT_EMPLOYMENT_SEARCH_ORDER",
        payload: data,
    }
}



//13th Question Put Call


export const putOtherOrders = (data) =>{
    return(dispatch)=>{
        API.put(`fl_342/update-fl-342-other-order`,data).then((res)=>{
            dispatch(successPutOtherOrders(data));
        })
    }
}

export const requestPutOtherOrders = () =>{
    return{
        type:"REQUEST_PUT_OTHER_ORDERS",
    }
}

export const successPutOtherOrders = (data) =>{
    return{
        type:"SUCCESS_PUT_OTHER_ORDERS",
        payload: data,
    }
}

export const errorPutOtherOrders = (data) =>{
    return{
        type:"ERROR_PUT_OTHER_ORDERS",
        payload: data,
    }
}




export const getChildSupport = (data) => {
    return(dispatch) => {
        dispatch(requestGetChildSupport(data))
        API.post ('fl_342/get-all-342-form-data', data).then((res)=>{
            let data = res.data;
            dispatch(successGetChildSupport(data));
        }).catch((error)=> 
        dispatch(errorGetChildSupport()));;
    };
};

export const requestGetChildSupport = () =>{
    return {
        type: "REQUEST_GET_CHILD_SUPPORT",
    }
}

export const successGetChildSupport = (data) =>{
    return {
        type: "SUCCESS_GET_CHILD_SUPPORT",
        payload: data,
    }
}

export const errorGetChildSupport = () =>{
    return {
        type: "ERROR_GET_CHILD_SUPPORT",
    }
}

// delete child call

export const requestDeleteChild = (data) => {
    return {
      type: "REQUEST_DELETE_CHILD",
    };
  };
  export const successDeleteChild = (data) => {
    return {
      type: "SUCCESS_DELETE_CHILD",
      payload: data,
    };
  };
  export const errorDeleteChild = (data) => {
    return {
      type: "ERROR_DELETE_CHILD",
      payload: data,
    };
  };
  
  export const  deleteChildCall = (data) => {
    return (dispatch) => {
      API.post(`fl_342/delete-base-child-data`,data).then((res) => {
        dispatch(successDeleteChild(res.data));
      });
    };
  };